import { useHeldEmailQueueTableModel } from "../../../hooks/admin/useHeldEmailQueueTableModel";
import { HeldEmailQueueTable } from "./HeldEmailQueueTable";
import { HeldEmailQueueErrorState } from "./HeldEmailQueueErrorState";
import { HeldEmailQueueViewModel } from "./heldEmailQueueViewModel";

export function HeldEmailQueueResults({
  model,
}: {
  model: HeldEmailQueueViewModel;
}) {
  const tableModel = useHeldEmailQueueTableModel(model);
  if (model.loading || model.error)
    return (
      <HeldEmailQueueErrorState error={model.error} loading={model.loading} />
    );
  return model.data ? <HeldEmailQueueTable model={tableModel} /> : null;
}
